import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
export type LoyaltyFragmentFragment = { __typename?: 'Loyalty', xPointsCurrencyCoef: number };

export const LoyaltyFragmentFragmentDoc = gql`
    fragment loyaltyFragment on Loyalty {
  xPointsCurrencyCoef
}
    `;